module.exports = __webpack_public_path__ + "ff1ea7f2e51f65a24cd768fa2aa9ea00.png";